import React from 'react';
import { useTranslation } from 'react-i18next';
import AddToGroup from '@wix/da-ds/pkg/Icons/AddToGroup';
import { BiDataHook, ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { useCustomNotifications } from '../../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../../Notifications';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../../redux/firstTimeFlags/hooks';
import SophisticatedFtueTooltip from '../../../Popover/Preset/SophisticatedFtueTooltip';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
const addToGroupNotificationType = [
    NotificationType.AddToGroup
];
export const AddToGroupButton = ({ activated , withTooltip , deviation , onClick  })=>{
    const { t  } = useTranslation();
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    // a ftue tooltip appears the first time a user submits a deviation
    // that suggests adding the deviation to a group
    const { hasFlag: hasAddToGroupFtue  } = useFirstTimeFlag(FirstTimeFlag.IsDevpageAddToGroupNotShown);
    const currentUrl = typeof window !== 'undefined' ? new URL(window.location.href) : undefined;
    const hasNewSubmissionUrlParam = !!(currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.searchParams.get('ga_submit_new'));
    const showingFtueTooltip = hasAddToGroupFtue && hasNewSubmissionUrlParam;
    // otherwise, addToGroup notificiations or the simple tooltip is shown
    const { notifications  } = useCustomNotifications(addToGroupNotificationType);
    const isShowingTooltip = withTooltip && !notifications.length;
    const tooltipText = isShowingTooltip ? t('actionbar.addToGroup') : undefined;
    const button = /*#__PURE__*/ React.createElement(ActionBarToggleButton, {
        activated: activated,
        onClick: restrictToLoggedIn(ReferralType.ADD_TO_GROUP, onClick),
        "data-hook": BiDataHook.DEVIATION_GROUPS_COUNTER,
        biData: BiData({
            evid: 340,
            deviationid: deviation.deviationId,
            sectionname: 'add_to_group'
        }),
        icon: AddToGroup
    });
    return showingFtueTooltip ? /*#__PURE__*/ React.createElement(SophisticatedFtueTooltip, {
        flag: FirstTimeFlag.IsDevpageAddToGroupNotShown,
        size: "medium",
        placement: "top",
        width: 290,
        hasCloseButton: true,
        prefix: /*#__PURE__*/ React.createElement("img", {
            loading: "lazy",
            alt: "IL44",
            src: "https://st.deviantart.net/eclipse/promos/il4-5.svg"
        }),
        heading: t('deviationview.groupPrompt.title'),
        description: t('deviationview.groupPrompt.message')
    }, button) : /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: tooltipText,
        notificationTypes: addToGroupNotificationType
    }, button);
};
AddToGroupButton.displayName = 'AddToGroupButton';
export default AddToGroupButton;
